<template>
    <modal :show.sync="showModal" size="lg">
        <h6 slot="header" class="modal-title">Visor de PDF</h6>
        <pdf @num-pages="actualizarTotalPaginacion" :page="pagina" style="width: 100%;" :src="url"></pdf>
        <template slot="footer">
            <base-button size="sm" :disabled="!download_url" tag="a" target="_blank" type="secondary"  :href="download_url" class="active" role="button" aria-pressed="true"><i class="fas fa-file-pdf"></i>  Descargar</base-button>
            <!--<base-button size="sm" nativeType="button" type="primary" ><i class="ni ni-bold-left"></i> Anterior</base-button>
            
            <base-button size="sm" nativeType="button" type="primary" >Siguiente <i class="ni ni-bold-right"></i></base-button>
            -->
            <base-pagination :pageCount="totalPaginacion" v-model="pagina"  :page-count="10" size="sm"></base-pagination>
            <base-button type="link" class="ml-auto" @click="showModal = false">Ok</base-button>
        </template>
    </modal>
</template>

<script>
import pdf from 'vue-pdf';

export default {
    components: {
        pdf
    },
    data(){
        return {
            showModal: false,
            url: 'https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/freeculture.pdf',
            download_url: undefined,
            pagina: 1,
            totalPaginacion: 1
        }
    },
    methods: {
        fetchUrl(entity, id){
            var vm = this;
            this.axios({
                url: 'api/ventas/url_formulario_siniestro?'+entity+'='+id,
                method: 'GET',
                responseType: 'blob',
            }).then( response => {
                var newBlob = new Blob([response.data], {type: "application/pdf"})
                let data = window.URL.createObjectURL(newBlob);
                vm.url = data;
                vm.showModal = true;
                vm.download_url = data;
            }).catch( error => {
                vm.download_url = undefined;
                if( error.response.data ) vm.$notify({type: 'warning', message: error.response.data});
            });
        },
        actualizarTotalPaginacion(value){
            this.totalPaginacion = value;
        }
    },
    created()
    {
      this.$parent.$on('loadFiniquitoPdf', (objeto) => { this.fetchUrl(objeto.entity, objeto.id) } );
    },
}
</script>
<style lang="scss">
.pagination.pagination-sm{
    margin-bottom: 0.1rem;
}
</style>